module.exports = __webpack_public_path__ + "static/gecmise-donuk-veri-kaydi-7525ae90e08072eb125c27f967e69f74.svg";